// Import plugins (they patch the global L object)
import '@arl/leaflet-tracksymbol2';
import 'leaflet.locatecontrol';
import 'leaflet.sidepanel';
import 'leaflet-ruler';
import 'leaflet-slidemenu';
import 'leaflet-contextmenu';
import 'leaflet-minimap';
import 'leaflet-spline';
import 'leaflet.coordinates/dist/Leaflet.Coordinates-0.1.5.min.js';
import 'leaflet-responsive-popup';
import 'leaflet-toolbar';
import 'leaflet.awesome-markers';

// Import Leaflet (after plugins patched it)
import * as _Leaflet from 'leaflet';

// 3. Extend the local L object with plugin typings
const L = { ..._Leaflet } as typeof _Leaflet & {
	AwesomeMarkers?: any;
	Toolbar2?: any;
	ResponsivePopup?: any;
	aisTrackSymbol?: (...args: any[]) => L.Marker;
	responsivePopup?: (...args: any[]) => L.Popup;
	spline?: (...args: any[]) => L.Polyline;
	control: typeof _Leaflet.control & {
		locate?: (...args: any[]) => L.Control;
		sidepanel?: (...args: any[]) => L.Control;
		coordinates?: (...args: any[]) => L.Control;
	};
	Control: typeof _Leaflet.Control & {
		Ruler: typeof _Leaflet.Control;
		MiniMap: typeof _Leaflet.Control;
		Coordinates: typeof _Leaflet.Control;
	}
};

export default L;
